function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M713.528 491.4L732.76 449.224L608.597 424.667L484.435 449.224L465.204 491.4L589.366 563.085L659.374 552.242L713.528 491.4Z",
  fill: "#D6D2CD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M264.896 534.64L284.127 492.464L159.965 467.907L35.8021 492.464L16.5708 534.64L140.733 606.326L264.896 534.64Z",
  fill: "#D6D2CD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M489.211 368.56L508.443 326.385L384.28 301.827L260.118 326.385L240.887 368.56L365.049 440.246L489.211 368.56Z",
  fill: "#D6D2CD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M384.653 112.242L260.49 183.927L229.074 242.888L353.237 171.203L384.653 112.242Z",
  fill: "#E0A173",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 143.37,
  height: 143.37,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 508.938 183.928)",
  fill: "#4E4E4E",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 104.784,
  height: 104.784,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 475.522 203.222)",
  fill: "black",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 143.37,
  height: 143.37,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 508.938 183.928)",
  fill: "#FFB681",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M466.332 208.529L386.527 254.604L386.527 397.086L450.155 359.207L466.332 208.529Z",
  fill: "#E0A173"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 25.052,
  height: 59.4845,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 475.086 254.596)",
  fill: "white",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M508.938 183.931L384.776 255.616L405.939 324.696L530.102 253.01L508.938 183.931Z",
  fill: "#FFDBC0",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M260.349 183.418L384.775 255.613L384.775 398.984L260.612 327.298L260.349 183.418Z",
  fill: "#E0A173",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  width: 143.37,
  height: 143.37,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 731.914 306.87)",
  fill: "#FFDBC0",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  width: 21.1478,
  height: 143.37,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 678.991 276.313)",
  fill: "white",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  width: 143.37,
  height: 143.37,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 731.914 306.87)",
  fill: "#FFB681",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  width: 29.8867,
  height: 30.3512,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 727.317 321.46)",
  fill: "#FFDBC0",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M671.238 368.911L607.751 378.557L607.751 521.928L671.238 512.281L671.238 368.911Z",
  fill: "#E0A173",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  width: 143.37,
  height: 143.37,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 483.589 306.87)",
  fill: "#4E4E4E",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  width: 101.265,
  height: 101.265,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 520.053 327.923)",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  width: 19.9244,
  height: 24.564,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 537.51 338.001)",
  fill: "white",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  width: 143.37,
  height: 143.37,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 284.625 350.008)",
  fill: "#FFDBC0",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  width: 67.6724,
  height: 143.37,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 284.625 350.01)",
  fill: "#FFDBC0",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  width: 26.1976,
  height: 34.0792,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 266.178 349.656)",
  fill: "white",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  width: 145.748,
  height: 19.4308,
  transform: "matrix(-0.866025 -0.5 -0.866025 0.5 231.99 381.586)",
  fill: "white",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  width: 143.37,
  height: 143.37,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 284.625 350.008)",
  fill: "#FFB681",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  width: 143.37,
  height: 143.37,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 36.2998 350.008)",
  fill: "#E0A173",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  width: 40.5595,
  height: 17.4237,
  transform: "matrix(0.866025 0.5 -2.20305e-08 1 80.8193 399.107)",
  fill: "#4E4E4E",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  width: 19.925,
  height: 48.4613,
  transform: "matrix(-0.866025 0.5 2.20305e-08 1 231.232 380.799)",
  fill: "white",
  stroke: "black",
  strokeWidth: 1.80005,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgEmptyPackages = function SvgEmptyPackages(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 749,
    height: 749,
    viewBox: "0 0 749 749",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyPackages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-packages.9cb650e6.svg";
export { ForwardRef as ReactComponent };